// config.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_CONFIG_DATA,
  SET_CONFIG_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

import env from '../resource/env.js';
import { EMPTY_OBJECT } from '../resource/defaults.js';
import { GrowthBookInitStatus } from '../resource/configConstants.js';

export const defaultState = fromJS({
  env,
  status: {
    initStatus: GrowthBookInitStatus.DEFAULT,
  },
});

/**
 * Config.
 * @module reducer/config
 */
const config = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_CONFIG_DATA:
      return _MERGE_CONFIG_DATA(action.payload)(state);
    case SET_CONFIG_DATA:
      return _SET_CONFIG_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge config data
 * @kind reducer/actionType
 * @name MERGE_CONFIG_DATA
 * @param {object} payload - payload
 * @return {Immutable.Map} New state
 */
const _MERGE_CONFIG_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Set config data
 * @kind reducer/actionType
 * @name SET_CONFIG_DATA
 * @param {object} payload - payload
 * @return {Immutable.Map} New state
 */
const _SET_CONFIG_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.setIn([...selectPath], fromJS(data));
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => state => {
  return defaultState.mergeDeep({
    status: {
      initStatus:
        state.getIn(['status', 'initStatus']) || GrowthBookInitStatus.DEFAULT,
    },
    attribute: {
      client: state.getIn(['attribute', 'client']) || EMPTY_OBJECT,
    },
    env: state.getIn(['env']) || EMPTY_OBJECT,
    webview: state.getIn(['webview']) || EMPTY_OBJECT,
    mdm: state.getIn(['mdm']) || EMPTY_OBJECT,
  });
};

export default config;
